import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { companyQuery } from "#modules/company/infra/company.query";
import {
  CompanySettingsPayload,
  updateCompanySetting,
} from "#modules/company/infra/updateCompanySetting.api";

export const useUpdateOnboardingMaterialMode = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (payload: CompanySettingsPayload) => updateCompanySetting(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries(companyQuery());
    },
    onError: (err) => {
      showErrorToast({ title: "Une erreur est survenue" });
      errorHandler(err);
    },
  });

  return { updateOnboardingMaterialMode: mutateAsync, isPending };
};
